
import SingleArticle from "./components/SingleArticle";

const Single = () => {

  return (
    <>
     <SingleArticle />
    </>
  );
};

export default Single;
